import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import AnimatedArrowButton from './AnimatedArrow';
import PulseButton from './PulseButton';
import ShimmerButton from './ShimmerButton';
import AnimatedFillButton from './AnimatedFillButton';
import AnimatedDepthButton from './AnimatedDepthButton';
import AnimatedUnderlineButton from './AnimatedUnderlineButton';
import { useTenant } from '../../../providers/tenant/TenantProvider';
import { FC } from 'react';
import { components } from '@jd/platform-config/constants';

type AllowedKeys = (typeof components.ctaButtons)[number]['value'];

const ButtonMap: Record<AllowedKeys, FC<ButtonProps>> = {
  animatedArrow: AnimatedArrowButton,
  animatedPulse: PulseButton,
  animatedShimmer: ShimmerButton,
  animatedFill: AnimatedFillButton,
  animatedDepth: AnimatedDepthButton,
  animatedUnderline: AnimatedUnderlineButton,
};

type Props = ButtonProps;

const CtaButton = (props: Props) => {
  const { tenantConfig } = useTenant();
  const tenantButtonKey = tenantConfig.theme?.components?.ctaButton;
  const TenantButton = ButtonMap[tenantButtonKey!] || Button;
  return <TenantButton {...props} />;
};

export default CtaButton;
